import { ONE_SECOND } from './constants';

export const EXPORT_STATUS_STARTED = 1;
export const EXPORT_STATUS_CANCELED = 2;
export const EXPORT_STATUS_FAILED = 3;
export const EXPORT_STATUS_COMPLETED = 4;

export const EXPORT_PARTNER_GET_PARTNER_INTERVAL = ONE_SECOND * 20;
